import { render, staticRenderFns } from "./CustomerSupports.vue?vue&type=template&id=4d0a4be8&"
import script from "./CustomerSupports.vue?vue&type=script&lang=js&"
export * from "./CustomerSupports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports